import {Categories} from 'emoji-picker-react';
import {texts} from './texts';

export const getCategories = () => {
    return [
        {
            name: texts.category_frequently_used,
            category: Categories.SUGGESTED
        },
        {
            name: texts.category_smileys_people,
            category: Categories.SMILEYS_PEOPLE
        },
        {
            name: texts.category_animals_nature,
            category: Categories.ANIMALS_NATURE
        },
        {
            name: texts.category_food_drink,
            category: Categories.FOOD_DRINK
        },
        {
            name: texts.category_travel_places,
            category: Categories.TRAVEL_PLACES
        },
        {
            name: texts.category_activities,
            category: Categories.ACTIVITIES
        },
        {
            name: texts.category_objects,
            category: Categories.OBJECTS
        },
        {
            name: texts.category_symbol,
            category: Categories.SYMBOLS
        },
        {
            name: texts.category_flags,
            category: Categories.FLAGS
        }
    ];
};
